import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  h3 {
    margin: 10px 2px;
    font-weight: bold;
  }
  div.category-wrapper, div.content-wrapper {
    width: 80%
    float: left;
    margin: 10px 2px;
  }
  div.post-wrapper {
    ul {
      display: inline-block;
      li {
        text-transform: none;
        list-style: circle;
        margin: 6px 46px 0;
        line-height: 27px;
      }
    }
  }
  div.img-wrapper {
    margin: 10px;
    border: 2px solid #ececec;
  }
  ul {
    display: flex;
    list-style: none;
    padding: 0;

    li {
      text-transform: uppercase;
      font-size: 1.3rem;

      & + li {
        margin-left: 2rem;
      }
    }
  }
`;